import { request } from '../request';

export type SingleShiftTemplatePresetEditData = {
  id: string;
  name: string;
  startTime: string;
  durationInSeconds: number;
  locationId: string; // 'location-00000000000000000000000000';
};

export async function updateSingleShiftTypePreset(data: SingleShiftTemplatePresetEditData) {
  return request.put<void>(`/v2/templates/time-presets`, {
    ...data,
  });
}
